import React from 'react';
import { Layout } from 'antd';
import TitleAndNew from '../Components/TitleAndNew/TitleAndNew';
import UploadLogo from '../Components/UploadLogo/UploadLogo';

const { Content } = Layout;

const AdminSettings = () => {
  return (
    <Layout>
      <Content style={{ margin: '36px', minHeight: '80vh' }}>
        <TitleAndNew titleText={'Ustawienia'} />
        <div
          style={{
            background: '#fff',
            padding: '16px',
            borderRadius: '8px',
          }}
        >
          <UploadLogo />
        </div>
      </Content>
    </Layout>
  );
};

export default AdminSettings;
